import type { CustomFieldableType } from './entity_types/CustomFieldValue';
import { hFetch as deprecatedHFetch } from './hFetch';

type UpdateCustomFieldValueArgs = {
  payload: {
    custom_fieldable_type: CustomFieldableType;
    custom_fieldable_id: number;
    custom_field_id: number;
    value: string;
  };
};
export const updateCustomFieldValue = ({ payload }: UpdateCustomFieldValueArgs) => {
  return deprecatedHFetch({
    url: '/api/custom_field_values',
    method: 'POST',
    payload: { custom_field_value: payload },
  }) as Promise<{ status: 'error' | 'success'; message: 'string' }>;
};

export const decryptCustomFieldValue = (customFieldValueId: number) => {
  return deprecatedHFetch({ url: `/api/custom_field_values/${customFieldValueId}/decrypt` }) as Promise<{
    record: { secure_value: string };
  }>;
};
